// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboardlayout {
    display: flex;
    max-width: 100%;
    height: 100vh;
    background-color: var(--bg);
}

.dashboardlayout_content {
    position: relative;
    overflow-y: auto;
    width: 100%;
    padding: 24px 32px;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.dashboardlayout_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 100%;
    padding: 4px 0 16px;
    position: relative;
    border-bottom: 1px solid var(--border-light);
}

.dashboardlayout_header_right {
    display: flex;
    align-items: center;
    gap: 10px;
}

.dashboardlayout_darkmode {
    width: 36px;
    height: 36px;
    border-radius: var(--radius-sm);
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--bg);
    color: var(--text-secondary);
    border: 1px solid var(--border);
    cursor: pointer;
    transition: all var(--transition-fast);
}

.dashboardlayout_darkmode:hover {
    background-color: var(--primary-light);
    color: var(--primary);
    border-color: var(--primary);
}

.dashboardlayout_history {
    display: flex;
    align-items: center;
    justify-content: start;
    gap: 16px;
}

.dashboardlayout_historyButton {
    display: flex;
    align-items: center;
    justify-content: start;
    gap: 4px;
}

.dashboardlayout_historyBack {
    width: 36px;
    height: 36px;
    border-radius: var(--radius-sm);
    display: flex;
    align-items: center;
    cursor: pointer;
    justify-content: center;
    transition: all var(--transition-fast);
    color: var(--text-muted);
}

.dashboardlayout_historyBack:hover {
    background-color: var(--bg);
    color: var(--text-primary);
}

.dashboardlayout_historyBack img {
    transform: rotate(90deg);
    opacity: 0.5;
    width: 12px;
}

.dashboardlayout_historyBack:hover img {
    opacity: 0.8;
}

.dashboardlayout_historyNext {
    width: 36px;
    height: 36px;
    border-radius: var(--radius-sm);
    display: flex;
    align-items: center;
    cursor: pointer;
    justify-content: center;
    transition: all var(--transition-fast);
    color: var(--text-muted);
}

.dashboardlayout_historyNext:hover {
    background-color: var(--bg);
    color: var(--text-primary);
}

.dashboardlayout_historyNext img {
    transform: rotate(-90deg);
    opacity: 0.5;
    width: 12px;
}

.dashboardlayout_historyNext:hover img {
    opacity: 0.8;
}

.dashboardlayout_title {
    margin: 0;
    color: var(--text-primary);
    font-weight: 600;
    font-size: 18px;
    font-style: normal;
}

.dashboardlayout_traduction {
    background-color: var(--bg-card);
    padding: 8px 16px;
    border-radius: var(--radius-sm);
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 500;
    color: var(--text-secondary);
    border: 1px solid var(--border);
    transition: all var(--transition-fast);
}

.dashboardlayout_traduction:hover {
    border-color: var(--primary);
    color: var(--text-primary);
}

.dashboardlayout_traduction img {
    height: 8px;
    width: 8px;
    opacity: 0.5;
}

.dashboardlayout_traductionModal {
    position: absolute;
    right: 0;
    bottom: 0;
    transform: translateY(100%);
    background-color: var(--bg-card);
    width: 140px;
    overflow-y: hidden;
    border-radius: var(--radius-md);
    max-height: 0;
    opacity: 0;
    transition: opacity 0.2s ease-in-out, max-height 0.3s ease-in-out;
    box-shadow: var(--shadow-lg);
    border: 1px solid var(--border);
    z-index: 10;
}

.dashboardlayout_traductionModalOpen {
    max-height: 300px;
    opacity: 1;
    padding: 6px;
}

.dashboardlayout_traductionListe {
    display: flex;
    flex-direction: column;
    gap: 2px;
    overflow-y: auto;
    height: 100%;
}

.dashboardlayout_traductionItem {
    margin: 0;
    cursor: pointer;
    border-radius: var(--radius-sm);
    max-width: 100%;
    padding: 8px 12px;
    font-size: 13px;
    font-weight: 500;
    color: var(--text-secondary);
    transition: all var(--transition-fast);
}

.dashboardlayout_traductionItem:hover {
    background-color: var(--primary-light);
    color: var(--primary);
}

/******************* TOASTERS ***********************/

.toaster {
    border-radius: var(--radius-md);
    padding: 12px 20px;
    width: 380px;
    display: flex;
    align-items: center;
    gap: 12px;
    box-shadow: var(--shadow-lg);
    font-size: 14px;
    font-weight: 500;
    animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.toaster svg {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
}

.toaster-component {
    min-width: 90%;
    max-width: 100%;
    position: absolute;
    top: 0;
    z-index: 100;
}

.toaster-relative {
    position: relative;
    display: flex;
    justify-content: center;
    padding-top: 20px;
}

.error-toaster {
    background-color: var(--danger-light);
    color: var(--danger);
    border: 1px solid var(--danger);
}

.loading-toaster {
    background-color: var(--bg-card);
    color: var(--text-secondary);
    border: 1px solid var(--border);
}

.response-toaster {
    background-color: var(--primary-light);
    color: var(--primary);
    border: 1px solid var(--primary-50);
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/dashboard/dashboardLayout.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,4BAA4B;IAC5B,+BAA+B;IAC/B,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;IACtC,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,sCAAsC;IACtC,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;IACxB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,sCAAsC;IACtC,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,+BAA+B;IAC/B,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;IAC5B,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B,gCAAgC;IAChC,YAAY;IACZ,kBAAkB;IAClB,+BAA+B;IAC/B,aAAa;IACb,UAAU;IACV,iEAAiE;IACjE,4BAA4B;IAC5B,+BAA+B;IAC/B,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,+BAA+B;IAC/B,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;IACtC,qBAAqB;AACzB;;AAEA,qDAAqD;;AAErD;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,MAAM;IACN,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;IACrC,oBAAoB;IACpB,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;IAChC,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,sCAAsC;IACtC,qBAAqB;IACrB,mCAAmC;AACvC","sourcesContent":[".dashboardlayout {\n    display: flex;\n    max-width: 100%;\n    height: 100vh;\n    background-color: var(--bg);\n}\n\n.dashboardlayout_content {\n    position: relative;\n    overflow-y: auto;\n    width: 100%;\n    padding: 24px 32px;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.dashboardlayout_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    max-width: 100%;\n    padding: 4px 0 16px;\n    position: relative;\n    border-bottom: 1px solid var(--border-light);\n}\n\n.dashboardlayout_header_right {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.dashboardlayout_darkmode {\n    width: 36px;\n    height: 36px;\n    border-radius: var(--radius-sm);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: var(--bg);\n    color: var(--text-secondary);\n    border: 1px solid var(--border);\n    cursor: pointer;\n    transition: all var(--transition-fast);\n}\n\n.dashboardlayout_darkmode:hover {\n    background-color: var(--primary-light);\n    color: var(--primary);\n    border-color: var(--primary);\n}\n\n.dashboardlayout_history {\n    display: flex;\n    align-items: center;\n    justify-content: start;\n    gap: 16px;\n}\n\n.dashboardlayout_historyButton {\n    display: flex;\n    align-items: center;\n    justify-content: start;\n    gap: 4px;\n}\n\n.dashboardlayout_historyBack {\n    width: 36px;\n    height: 36px;\n    border-radius: var(--radius-sm);\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    justify-content: center;\n    transition: all var(--transition-fast);\n    color: var(--text-muted);\n}\n\n.dashboardlayout_historyBack:hover {\n    background-color: var(--bg);\n    color: var(--text-primary);\n}\n\n.dashboardlayout_historyBack img {\n    transform: rotate(90deg);\n    opacity: 0.5;\n    width: 12px;\n}\n\n.dashboardlayout_historyBack:hover img {\n    opacity: 0.8;\n}\n\n.dashboardlayout_historyNext {\n    width: 36px;\n    height: 36px;\n    border-radius: var(--radius-sm);\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    justify-content: center;\n    transition: all var(--transition-fast);\n    color: var(--text-muted);\n}\n\n.dashboardlayout_historyNext:hover {\n    background-color: var(--bg);\n    color: var(--text-primary);\n}\n\n.dashboardlayout_historyNext img {\n    transform: rotate(-90deg);\n    opacity: 0.5;\n    width: 12px;\n}\n\n.dashboardlayout_historyNext:hover img {\n    opacity: 0.8;\n}\n\n.dashboardlayout_title {\n    margin: 0;\n    color: var(--text-primary);\n    font-weight: 600;\n    font-size: 18px;\n    font-style: normal;\n}\n\n.dashboardlayout_traduction {\n    background-color: var(--bg-card);\n    padding: 8px 16px;\n    border-radius: var(--radius-sm);\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--text-secondary);\n    border: 1px solid var(--border);\n    transition: all var(--transition-fast);\n}\n\n.dashboardlayout_traduction:hover {\n    border-color: var(--primary);\n    color: var(--text-primary);\n}\n\n.dashboardlayout_traduction img {\n    height: 8px;\n    width: 8px;\n    opacity: 0.5;\n}\n\n.dashboardlayout_traductionModal {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    transform: translateY(100%);\n    background-color: var(--bg-card);\n    width: 140px;\n    overflow-y: hidden;\n    border-radius: var(--radius-md);\n    max-height: 0;\n    opacity: 0;\n    transition: opacity 0.2s ease-in-out, max-height 0.3s ease-in-out;\n    box-shadow: var(--shadow-lg);\n    border: 1px solid var(--border);\n    z-index: 10;\n}\n\n.dashboardlayout_traductionModalOpen {\n    max-height: 300px;\n    opacity: 1;\n    padding: 6px;\n}\n\n.dashboardlayout_traductionListe {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    overflow-y: auto;\n    height: 100%;\n}\n\n.dashboardlayout_traductionItem {\n    margin: 0;\n    cursor: pointer;\n    border-radius: var(--radius-sm);\n    max-width: 100%;\n    padding: 8px 12px;\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--text-secondary);\n    transition: all var(--transition-fast);\n}\n\n.dashboardlayout_traductionItem:hover {\n    background-color: var(--primary-light);\n    color: var(--primary);\n}\n\n/******************* TOASTERS ***********************/\n\n.toaster {\n    border-radius: var(--radius-md);\n    padding: 12px 20px;\n    width: 380px;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    box-shadow: var(--shadow-lg);\n    font-size: 14px;\n    font-weight: 500;\n    animation: slideDown 0.3s ease-out;\n}\n\n@keyframes slideDown {\n    from {\n        opacity: 0;\n        transform: translateY(-10px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.toaster svg {\n    flex-shrink: 0;\n    width: 32px;\n    height: 32px;\n}\n\n.toaster-component {\n    min-width: 90%;\n    max-width: 100%;\n    position: absolute;\n    top: 0;\n    z-index: 100;\n}\n\n.toaster-relative {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    padding-top: 20px;\n}\n\n.error-toaster {\n    background-color: var(--danger-light);\n    color: var(--danger);\n    border: 1px solid var(--danger);\n}\n\n.loading-toaster {\n    background-color: var(--bg-card);\n    color: var(--text-secondary);\n    border: 1px solid var(--border);\n}\n\n.response-toaster {\n    background-color: var(--primary-light);\n    color: var(--primary);\n    border: 1px solid var(--primary-50);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
